const BuildingTypes = [
    {
        name: 'Detached',
        icon: 'sa sa-detached'
    },
    {
        name: 'Semi-Detached',
        icon: 'sa sa-semi-detached'
    },
    {
        name: 'Terraced',
        icon: 'sa sa-terraced'
    },
    {
        name: 'Bungalow',
        icon: 'sa sa-bungalow'
    },
    {
        name: 'Flat',
        icon: 'sa sa-apartment'
    },
    {
        name: 'Other',
        icon: 'sa sa-question'
    },
];

const Bedrooms = [
    '1',
    '2',
    '3',
    '4',
    '5 or more'
];

const Availabilities = [
    'Any time',
    'Morning',
    'Afternoon',
    'Evening',
];

export {
    BuildingTypes,
    Bedrooms,
    Availabilities,
}
